//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import styled from 'styled-components'
import DatetimeInput from 'components/Shared/DatetimeInput/Index'

import { customIsEqual } from './utils'

const StyledDatetimeInput = styled(DatetimeInput)`
  width: auto;
  margin-right: 80px;
`

const DateTimeField = ({
  name, placeholder, disabled, validate, userTimeZone, isDateOnly,
}) => {
  return (
    <Field
      name={name}
      isEqual={customIsEqual}
      validate={validate}
    >
      {({ input, meta }) => {
        return (
          <StyledDatetimeInput
            value={input.value}
            onChange={input.onChange}
            userTimeZone={userTimeZone}
            placeholder={placeholder}
            isDateOnly={isDateOnly}
            isReadOnly={disabled}
          />
        )
      }}
    </Field>
  )
}

DateTimeField.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  validate: PropTypes.func,
  userTimeZone: PropTypes.string,
  isDateOnly: PropTypes.bool,
}

export default DateTimeField
